export const faqItems = [
  {
    question: '众赢国际网页版登录入口在哪里？',
    answer: '众赢国际网页版登录入口位于官方网站首页右上角，点击"登录"按钮即可进入登录页面。建议将官方网址添加到浏览器收藏夹，避免通过搜索引擎进入仿冒网站。',
  },
  {
    question: '忘记众赢国际登录密码怎么办？',
    answer: '在登录页面点击"忘记密码"，输入注册手机号或邮箱接收验证码，验证身份后即可重新设置密码。如遇问题可联系在线客服协助处理。',
  },
  {
    question: '众赢国际网页版支持哪些浏览器？',
    answer: '众赢国际网页版全面支持Chrome、Firefox、Safari、Edge等主流浏览器的最新版本。建议使用Chrome浏览器以获得最佳使用体验。',
  },
  {
    question: '众赢国际平台是否安全可靠？',
    answer: '众赢国际平台采用银行级加密技术，用户资金与平台运营资金完全隔离，并设有专项风险准备金。平台严格遵守监管要求，定期接受第三方安全审计。',
  },
  {
    question: '众赢国际是否收取账户管理费？',
    answer: '众赢国际不收取任何账户管理费用。开户免费，用户只需承担交易过程中的正常手续费用，具体费率可在平台费率页面查看。',
  },
  {
    question: '众赢国际出入金需要多长时间？',
    answer: '入金通常在5-30分钟内到账，具体取决于支付方式。出金申请审核通过后，资金一般在1个工作日内到达您的银行账户。',
  },
  {
    question: '如何联系众赢国际客服？',
    answer: '您可以通过以下方式联系客服：在线客服（7×24小时）、官方客服热线、官方微信公众号、官方邮箱。建议优先使用在线客服获取最快响应。',
  },
  {
    question: '众赢国际支持哪些交易品种？',
    answer: '众赢国际支持多种交易品种，包括股票、外汇、商品期货、指数等。具体可交易品种请在登录后的交易界面查看完整列表。',
  },
];

export const features = [
  {
    title: '安全可靠',
    description: '银行级加密技术，资金托管保障，多重安全防护，确保您的资产安全无忧。',
    icon: 'ri-shield-check-line',
  },
  {
    title: '极速交易',
    description: '毫秒级交易执行，低延迟行情推送，让您在瞬息万变的市场中把握先机。',
    icon: 'ri-flashlight-line',
  },
  {
    title: '专业工具',
    description: '配备80+技术指标、多种图表工具，满足专业投资者的分析需求。',
    icon: 'ri-tools-line',
  },
  {
    title: '便捷操作',
    description: '简洁直观的操作界面，一键下单、智能止损，让交易变得简单高效。',
    icon: 'ri-smartphone-line',
  },
  {
    title: '全天候服务',
    description: '7×24小时在线客服支持，专业团队随时为您解答交易中的疑问。',
    icon: 'ri-customer-service-2-line',
  },
  {
    title: '丰富品种',
    description: '涵盖股票、外汇、商品、指数等多种交易品种，满足多元化投资需求。',
    icon: 'ri-funds-line',
  },
];

export const stats = [
  { label: '注册用户', value: '500,000+' },
  { label: '安全运营', value: '8年' },
  { label: '交易品种', value: '200+' },
  { label: '客服满意度', value: '98.6%' },
];

export const aboutTimeline = [
  { year: '2016', title: '公司成立', description: '众赢国际正式成立，开启金融科技服务之路。' },
  { year: '2017', title: '平台上线', description: '自主研发的交易平台正式上线运营，首批用户入驻。' },
  { year: '2019', title: '用户突破', description: '注册用户突破10万，交易量持续快速增长。' },
  { year: '2021', title: '技术升级', description: '完成核心交易系统全面升级，引入AI智能风控体系。' },
  { year: '2023', title: '国际化布局', description: '拓展国际市场，服务覆盖全球多个国家和地区。' },
  { year: '2024', title: '品牌升级', description: '品牌全面焕新，用户数突破50万，开启发展新篇章。' },
];

export const contactInfo = {
  phone: '400-xxx-xxxx',
  email: 'support@zhongyingguoji.com',
  wechat: '众赢国际官方',
  address: '北京市朝阳区建国路xx号',
  workingHours: '周一至周日 7×24小时',
};